import { carousels, carousels_mobile, carouselInit } from './carousel';

const TRACK_SELECTOR = '[data-hero-carousel-track]';

/**
 * Index of a slide among the *real* slides. In loop mode the track is padded
 * with cloned slides, so a plain `indexOf` over `track.children` is off by the
 * number of leading clones.
 */
const realIndexOf = (carousel, slide) => {
  if (!carousel || !slide) return -1;
  const track = carousel.querySelector(TRACK_SELECTOR) || carousel;
  const realSlides = Array.from(track.children).filter((child) => !child.hasAttribute('data-clone'));
  return realSlides.indexOf(slide);
};

export default function () {
  document.addEventListener('shopify:section:load', (e) => {
    const section_id = e.detail.sectionId;
    // Is this a carousel?
    const heroCarousel = document.querySelector(`#HeroCarousel${section_id}`);
    if (heroCarousel) {
      let index = 0;
      let mobile_index = 0;

      // Guard each map independently — a section can initialize one instance
      // and bail on the other via the <2-slide check, so keying the mobile
      // teardown off the desktop entry would throw.
      if (carousels[section_id]) {
        // Save the current slide's index so we can immediately reinitialize at the same slide later
        index = carousels[section_id].selectedIndex;
        carousels[section_id].destroy();
        delete carousels[section_id];
      }

      if (carousels_mobile[section_id]) {
        mobile_index = carousels_mobile[section_id].selectedIndex;
        carousels_mobile[section_id].destroy();
        delete carousels_mobile[section_id];
      }

      // Reinitialize the carousel with new options
      carouselInit(section_id, heroCarousel, index);
      carouselInit(section_id, document.querySelector(`#HeroCarousel--mobile${section_id}`), mobile_index);
    }
  });

  document.addEventListener('shopify:block:select', (e) => {
    const section_id = e.detail.sectionId;
    // Is this a carousel?
    const heroCarousel = document.querySelector(`#HeroCarousel${section_id}`);
    if (!heroCarousel) return;

    // Navigate to the correct slide and pause autoplay
    const block_id = e.detail.blockId;
    const index = realIndexOf(heroCarousel, document.querySelector(`#HeroSlide${block_id}`));
    if (index < 0) return;

    if (carousels[section_id]) {
      carousels[section_id].select(index);
      carousels[section_id].pausePlayer();
    }
    if (carousels_mobile[section_id]) {
      carousels_mobile[section_id].select(index);
      carousels_mobile[section_id].pausePlayer();
    }
  });

  document.addEventListener('shopify:block:deselect', (e) => {
    const section_id = e.detail.sectionId;
    // Is this a carousel?
    const heroCarousel = document.querySelector(`#HeroCarousel${section_id}`);
    if (!heroCarousel) return;

    // Unpause autoplay
    if (carousels[section_id]) {
      carousels[section_id].unpausePlayer();
    }
    if (carousels_mobile[section_id]) {
      carousels_mobile[section_id].unpausePlayer();
    }
  });
}
